import { getAccessToken } from "../../../api/authService";
import { ReadRecordRequest, SaveRecordRequest } from "../../../types";
import { getAPIBffBase } from "../../../utils";

export type RecordApiOperation =
  | "create"
  | "get"
  | "read"
  | "update"
  | "delete"
  | "delete-by-criteria"
  | "search"
  | "batch-process"
  | "batch-validate";

export const getRecordApiHeadersAndEndPoint = (
  request: SaveRecordRequest | ReadRecordRequest,
  method: RecordApiOperation,
): { headers: Record<string, string>; url: string } => {
  let headers: Record<string, string>;
  let url: string;
  const BFF_API_URL = getAPIBffBase();

  switch (request.functionalArea) {
    case "accounting":
      headers = {
        "x-store-id": request.storeId,
        "x-enterprise-id": request.enterpriseId,
        "x-department-name": request.accountName,
        "x-group-id": request.groupId ?? ""
      };
      url = `${BFF_API_URL}accounting-setups/${method}/${request.functionalArea}/${request.functionalUnitName}`;
      break;
    case "service":
      headers = {
        "x-store-id": request.storeId,
        "x-enterprise-id": request.enterpriseId,
        "x-department-name": request.accountName,
        "x-department-id": request.departmentId ?? "",
      };
      url = `${BFF_API_URL}service-setups/${method}/${request.functionalArea}/${request.functionalUnitName}`;
      break;
    case "parts":
      headers = {
        "x-store-id": request.storeId,
        "x-enterprise-id": request.enterpriseId,
        "x-department-name": request.accountName,
        "x-department-id": request.departmentId,
      };
      url = `${BFF_API_URL}parts-setups/${method}/${request.functionalArea}/${request.functionalUnitName}`;
      break;
    default:
      headers = {
        "x-store-id": request.storeId,
        "x-enterprise-id": request.enterpriseId,
        "x-department-name": request.accountName,
      };
      url = `${BFF_API_URL}functionalUnit/${method}/${request.functionalArea}/${request.functionalUnitName}`;
      break;
  }

  return {
    headers: { ...headers, Authorization: `Bearer ${getAccessToken()}` },
    url,
  };
};
